export default __webpack_public_path__ + "static/media/contract.89587c09.png";